import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Session } from 'src/app/models/session';

@Component({
  selector: 'app-nuevo-tecnico',
  templateUrl: './nuevo-tecnico.component.html',
  styleUrls: ['./nuevo-tecnico.component.css']
})
export class NuevoTecnicoComponent implements OnInit {

  constructor(private service: UserService, private toast: ToastrService,private router: Router, private session: Session) { }

  ngOnInit() {
  }

  data: any = {};

  showPassword = false;

  register(){
    let tecnico = {
      nombre: this.data.nombre,
      apellido: this.data.apellido,
      email: this.data.email,
      legajo: this.data.legajo,
      password: this.data.password,
      telefono: this.data.telefono,
      domicilio: this.data.domicilio,
      localidad: this.data.localidad,
      provincia: this.data.provincia
    }
    this.service.postTecnico(tecnico).subscribe(d=>{
      this.router.navigate(['/tecnicos']);
    }, er=>{
      this.toast.error(er.error);
    })
  }

  mock(){
    let aux = (new Date()).getTime();
    this.data.nombre = "Alberto";
    this.data.apellido = "Sosa";
    this.data.email = (this.data.nombre+"_"+this.data.apellido+"_"+aux+"@gmail.com").toLocaleLowerCase();
    this.data.legajo = aux +"";
    this.data.password = "1234";
    this.data.telefono = "(11) 4444-4444";
    this.data.domicilio = "Calle falsa 1234 1A"
    this.data.localidad = "Belgrano"
    this.data.provincia = "CABA"

  }

}
